import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { TextField, InputAdornment } from '@material-ui/core'
import Moji from 'moji/src/moji.standalone'

function NumberFormatCustom (props) {
  const { inputRef, onChange, ...other } = props

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        })
      }}
      thousandSeparator
      isNumericString
    />
  )
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default function MyReactInput (props) {
  const { labelText, inputProps } = props
  const typeNumber = (inputProps.type === 'number')
  if (!inputProps.decimalPlace) {
    inputProps.decimalPlace = 0
  }

  const [input, setInput] = useState(inputProps.value ? (typeNumber ? Number(inputProps.value).toFixed(inputProps.decimalPlace) : inputProps.value) : '') // 表示上の値
  const [value, setValue] = useState(input ? (typeNumber ? Number(`${input}`.replaceAll(',', '')) : input) : '') // コンポーネント外から見た値
  const valueRef = useRef(null)

  useEffect(() => {
    valueRef.current?.dispatchEvent(new Event('change')) // コードからの変更ではchangeイベントが発火しないので、手動で発火させる
  }, [value])

  function setOuterValue (tValue) {
    if (typeNumber && tValue) {
      const d10 = Math.pow(10, inputProps.decimalPlace)
      const val = Math.round(Number(`${tValue}`.replaceAll(',', '')) * d10) / d10
      const min = Number(inputProps.min)
      const max = Number(inputProps.max)
      if ('min' in inputProps && val < min) {
        setInput(min.toFixed(inputProps.decimalPlace))
        setValue(min)
      } else if ('max' in inputProps && val > max) {
        setInput(max.toFixed(inputProps.decimalPlace))
        setValue(max)
      } else {
        setInput(val.toFixed(inputProps.decimalPlace))
        setValue(val)
      }
    } else {
      setInput(tValue)
      setValue(tValue)
    }
  }

  return (
    <>
      <TextField
        variant="standard"
        id={inputProps.id}
        name=""
        type={typeNumber ? 'text' : (inputProps.type ?? 'text')} // type=numberの場合、カンマ区切りの表示のためtext
        required={inputProps.required}
        value={input}
        label={labelText}
        placeholder=""
        error={inputProps.error}
        helperText={inputProps.helperText}
        multiline={inputProps.multilineRows > 1}
        minRows={inputProps.multilineRows}
        maxRows={inputProps.multilineRows}
        className='w-100'
        onFocus={(e) => e.target.select()}
        onChange={(e) => {
          setInput(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setOuterValue(input)
          }
        }}
        onBlur={(e) => {
          let value = e.target.value
          if (props.onlyKatakana) {
            value = (new Moji(value))
              .convert('HK', 'ZK')
              .filter('ZK')
              .toString()
          }
          setOuterValue(value)
        }}
        InputProps={{
          className: inputProps.class,
          disabled: inputProps.readonly,
          endAdornment: inputProps.adornment ? <InputAdornment position='end'>{inputProps.adornment}</InputAdornment> : undefined,
          inputComponent: typeNumber ? NumberFormatCustom : undefined
        }}
        inputProps={{
          maxLength: inputProps.maxlength
        }}
      />
      {inputProps.multilineRows > 1
        ? (
        <textarea ref={valueRef} name={inputProps.name} className="d-none" readOnly value={value}></textarea>
          )
        : (
        <input ref={valueRef} type="text" name={inputProps.name} className="d-none" value={value} readOnly />
          )}
    </>
  )
}

MyReactInput.propTypes = {
  labelText: PropTypes.string,
  inputProps: PropTypes.object,
  onlyKatakana: PropTypes.bool
}

MyReactInput.defaultProps = {
  onlyKatakana: false
}

const elem = $('.my-react-input')
elem.each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  const elLabel = qel.find('label')
  props.labelText = elLabel.length > 0 ? elLabel[0].innerText : ''
  const elInput = qel.find('input')
  const elText = qel.find('textarea')
  if (elInput.length) {
    const qInput = $(elInput[0])
    props.inputProps = {}
    'id,name,value,type,required,readonly,class,min,max,maxlength'.split(',').forEach((name) => {
      if (qInput.prop(name)) {
        props.inputProps[name] = qInput.prop(name)
      }
    })
    if (qInput.hasClass('is-invalid')) {
      props.inputProps.error = true
    }
    props.inputProps.multilineRows = parseInt(qInput.attr('multiline-rows') ?? '1')
    props.inputProps.decimalPlace = qInput.data('decimalPlace') || 0
    props.inputProps.adornment = qInput.data('adornment')

    const elInvalidFeedback = qel.find('.invalid-feedback')
    props.inputProps.helperText = elInvalidFeedback.length > 0 ? elInvalidFeedback[0].innerText : ''
  } else if (elText.length) {
    const qText = $(elText[0])
    props.inputProps = {}
    'id,name,required,readonly,class,maxlength'.split(',').forEach((name) => {
      if (qText.prop(name)) {
        props.inputProps[name] = qText.prop(name)
      }
    })
    props.inputProps.value = qText.prop('value').trim()
    if (qText.hasClass('is-invalid')) {
      props.inputProps.error = true
    }
    props.inputProps.multilineRows = parseInt(qText.attr('rows') ?? '1')

    const elInvalidFeedback = qel.find('.invalid-feedback')
    props.inputProps.helperText = elInvalidFeedback.length > 0 ? elInvalidFeedback[0].innerText : ''
  } else {
    console.error('my-react-inputクラスの子要素には必ずinput要素かtextarea要素を配置してください。')
    return
  }
  ReactDOM.render(<MyReactInput {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
